import { GenIcon } from '../helpers/IconBase.es.js';

const FillColorShapeOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M3 19.5C3 18.6716 3.67157 18 4.5 18H19.5C20.3284 18 21 18.6716 21 19.5C21 20.3284 20.3284 21 19.5 21H4.5C3.67157 21 3 20.3284 3 19.5Z",
          fill: "#7D7D7D"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M17.5001 11.87C17.5001 11.87 16.0001 13.49 16.0001 14.49C16.0001 15.32 16.6701 15.99 17.5001 15.99C18.3301 15.99 19.0001 15.32 19.0001 14.49C19.0001 13.5 17.5001 11.87 17.5001 11.87ZM15.7101 9.79L8.91006 3L7.85006 4.06L9.44006 5.65L5.29006 9.79C4.90006 10.18 4.90006 10.81 5.29006 11.2L9.79006 15.7C9.99006 15.9 10.2401 16 10.5001 16C10.7601 16 11.0101 15.9 11.2101 15.71L15.7101 11.21C16.1001 10.82 16.1001 10.18 15.7101 9.79ZM7.21006 10L10.5001 6.71L13.7901 10H7.21006Z",
          fill: "#7D7D7D"
        }
      }
    ]
  })(props);
};

export { FillColorShapeOutlined };
